
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { DraggingOffsets, Size } from "../../../../../../../base/domain/drawing";
import { DragKinds } from "../../../../../../../base/components/dragging";
import { ModelEditableMixin } from "../../../../../../../base/components/system/mixins";
import { IFormatObjectEditable } from "../../../../../../domain/editableFormat";
import { FormatObjectEditableMixin, NamePropertyEditableMixin } from "../../../mixins";
import { ObjectUpdatesPromptableMixin } from "../../trackers/mixins";

@Component
export default class ObjectDrawerBase extends Mixins(ModelEditableMixin, FormatObjectEditableMixin, NamePropertyEditableMixin, ObjectUpdatesPromptableMixin) {
  @Prop()
  offsets: DraggingOffsets<IFormatObjectEditable>;

  @Prop({ default: 1 })
  scale: number;

  @Prop({ default: true })
  isHandleable: boolean;

  get shouldShowHandle(): boolean {
    return this.isHandleable && this.isSelected;
  }

  @Emit()
  dragHandleSelected(event: PointerEvent, kind: DragKinds): void {
    this.promptForObjectUpdates(event);
  }

  get handleSize(): Size {
    return new Size(this.handleWidth, this.handleHeight);
  }

  get handleWidth(): number {
    return this.adjustHandleSize(this.$configuration.formatEditor.behavior.format.editor.handles.size.width);
  }

  get handleHeight(): number {
    return this.adjustHandleSize(this.$configuration.formatEditor.behavior.format.editor.handles.size.height);
  }

  private adjustHandleSize(size: number): number {
    return size / this.scale;
  }
}
